export default __webpack_public_path__ + "static/media/speakers__christa-mrgan.80bc396d.jpg";